"use client";
import { usePDF, Document, Page } from "@react-pdf/renderer";
import { useMemo, useEffect, useCallback } from "react";
import { ReactElement } from "react";
import { DocumentProps } from "@react-pdf/renderer";

interface SafePDFManagerProps {
  document: JSX.Element | null;
  onPDFReady?: (instance: { url: string | null; loading: boolean; error: string | null }) => void;
  onUpdateReady?: (update: (newDocument: ReactElement<DocumentProps>) => void) => void;
}

export const SafePDFManager: React.FC<SafePDFManagerProps> = ({ document, onPDFReady, onUpdateReady }) => {
  // Create a fallback document if none provided
  const fallbackDocument = useMemo(() => (
    <Document>
      <Page></Page>
    </Document>
  ), []);

  // Use the usePDF hook directly - this is the correct way
  const [instance, update] = usePDF({ 
    document: document || fallbackDocument
  });

  // Debug the PDF instance
  useEffect(() => {
    // console.log("SafePDFManager - PDF instance:", instance);
    // console.log("SafePDFManager - Document:", document);
  }, [instance, document]);

  // Safe update function wrapper
  const safeUpdate = useCallback((newDocument: ReactElement<DocumentProps>) => {
    try {
      update(newDocument);
    } catch (error) {
      console.warn("PDF update error:", error);
    }
  }, [update]);

  // Use useEffect to notify parent component when PDF is ready
  useEffect(() => {
    if (onPDFReady) {
      onPDFReady(instance);
    }
  }, [instance, onPDFReady]);

  // Use useEffect to notify parent component when update function is ready
  useEffect(() => {
    if (onUpdateReady) {
      onUpdateReady(safeUpdate);
    }
  }, [safeUpdate, onUpdateReady]);

  return null;
};